import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { darken } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import Portal from "../ui/portal.js";
import PortalAppBar from "../ui/portalAppBar.js";
import PortalGridContent from "../ui/portalGridContent.js";
import BotpressTestHarness from "../widgets/botpressTestHarness.js";
import BotpressUserFeedback from "../widgets/botpressUserFeedback.js";

const BotpressTestHarnessPortal = props => {
  const { botpressBotODM } = props;
  const theme = useTheme();

  return (
    <Portal
      displayHeader={false}
      sx={{
        backgroundSize: "cover",
        backgroundColor: darken(theme.palette.commonground.main, 0.4),
      }}
    >
      <PortalAppBar title="Testing Harness" />
      <PortalGridContent>
        <Grid item size={{ xs: 12, sm: 6, lg: 5 }}>
          {botpressBotODM && <BotpressTestHarness widgetSize={"full"} minHeight={"100%"} />}
        </Grid>
        <Grid item size={{ xs: 12, sm: 6, lg: 7 }}>
          <BotpressUserFeedback />
        </Grid>
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  botpressBotODM: state.botpressSession.botpressBotODM,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BotpressTestHarnessPortal));

// const BotpressTestHarnessPortal = () => {
//   //#region theme intialization

//   const theme = useTheme();

//   // const themeConfig = buildTheme({
//   //   themeName: "light",
//   //   themeColor: "#dddddd",
//   // });

//   // //jfc this is the worst
//   // themeConfig.style = themeConfig.style.replace(
//   //   `button,[type='button'],[type='reset'],[type='submit']`,
//   //   `button,[type='reset'],[type='submit']`,
//   // );

//   // //inject default lstyle
//   // var styles = document.createElement("link");
//   // styles.rel = "stylesheet";
//   // styles.type = "text/css";
//   // styles.href =
//   //   "https://omni-public-media.s3.us-west-2.amazonaws.com/botResources/harness/harnessBot.css";
//   // document.getElementsByTagName("head")[0].appendChild(styles);

//   //#endregion

//   //#region Query Parameters

//   //Flag Defs:
//   //  botID
//   //  avatarID - number
//   //  languageCode - the code
//   //  tts- bool

//   let queryParameters = {};
//   const urlParams = new URLSearchParams(window.location.search);
//   for (var [key, value] of urlParams.entries()) {
//     queryParameters[key] = value;
//   }
//   //#endregion

//   //   let webchatClientID = "1d9c1910-60da-4fa2-a237-89fd3122b711";
//   let webchatClientID = null;

//   if (queryParameters.botID != null) {
//     webchatClientID = queryParameters.botID;
//   }

//   // const botConfiguration = getWebchatConfiguration(webchatClientID);

//   // const [botDisplayName] = useState(botConfiguration.displayIdentifier);

//   // const [languageCode, setLanguageCode] = useState("en-US");

//   // //if this doesn't exist, then we don't have a bot to connect to
//   // const webchatClient = useClient({
//   //   clientId: webchatClientID,
//   // });

//   // const inputRef = useRef(null);

//   // //#region Edited bot Configuration

//   // const createDefaultBotConfiguration = queryParams => {
//   //   //eventually we will do some sort of lookup from a config table or hard coded data
//   //   let tmpUserData = { ...botConfiguration };

//   //   delete tmpUserData["userData"];
//   //   delete tmpUserData["displayIdentifier"];
//   //   delete tmpUserData["botId"];

//   //   //will always have a languageCode set
//   //   return JSON.stringify(tmpUserData, null, 2);
//   // };

//   // const [botData, setBotData] = useState(
//   //   createDefaultBotConfiguration(queryParameters),
//   // );
//   const [botData, setBotData] = useState(null);

//   // const [newBotConfiguration, setNewBotConfiguration] = useState(null);

//   // //#endregion

//   // //#region Edited User Data

//   // const createDefaultUserData = queryParams => {
//   //   //eventually we will do some sort of lookup from a config table or hard coded data
//   //   let tmpUserData = { ...botConfiguration.userData };

//   //   for (var [key, value] of urlParams.entries()) {
//   //     if (key !== "botID") {
//   //       tmpUserData[key] = value;
//   //     }
//   //   }

//   //   //will always have a languageCode set
//   //   return JSON.stringify(tmpUserData, null, 2);
//   // };

//   // const [userData, setUserData] = useState(createDefaultUserData(queryParameters));

//   // const [newUserData, setNewUserData] = useState(null);
//   // //#endregion

//   // //these two data structures guard the bot from instantiation until the userData and botData are set
//   const [userData, setUserData] = useState(null);
//   const [botData, setBotData] = useState(null);

//   // //   const [anchorEl, setAnchorEl] = useState(null);

//   // const [message, setMessage] = useState(null);

//   // // for when we can intercept the messages
//   // // const [isTyping, setIsTyping] = useState(false);
//   // //is typing can be passed into the webchat client to set if you need to know
//   // const [volume, setVolume] = useState(0.5);
//   // const [speechConfig, setSpeechConfig] = useState(null);
//   // const [textToSpeechQueue, setTextToSpeechQueue] = useState([]);
//   // const [textToSpeechEnabled, setTextToSpeechEnabled] = useState(false);

//   // useEffect(() => {
//   //   if (message && textToSpeechEnabled && speechConfig) {
//   //     (async () => {
//   //       try {
//   //         // console.info("adding URL", message);
//   //         // const url = await convertTextToSpeech(message, speechConfig);
//   //         // console.info("here's your blob", url);
//   //         // setTextToSpeechQueue(prev => [...prev, url]);
//   //         console.info("adding URL", message);
//   //         convertTextToSpeech(message, speechConfig).then(url => {
//   //           console.info("here's your blob", url);
//   //           setTextToSpeechQueue(prev => [...prev, url]);
//   //         });
//   //       } catch (error) {
//   //         console.error("Error generating text-to-speech URL:", error);
//   //       }
//   //     })();
//   //   }
//   //   // setMessage(null);
//   // }, [message, textToSpeechEnabled, speechConfig, setMessage, setTextToSpeechQueue]);

//   //#region Download Conversation
//   // const [downloadConversation, setDownloadConversation] = useState(null);

//   // const handleDownloadConversation = async (fileName = "Conversation") => {
//   //   const conversationId = webchatClient.conversationId;
//   //   let allMessages = [];
//   //   let paginationToken;
//   //   const getMessages = await webchatClient.listMessages({
//   //     conversationId,
//   //     nextToken: paginationToken,
//   //   });

//   //   allMessages = allMessages.concat(getMessages);

//   //   allMessages.reverse();

//   //   let theJSON = createConversationJSON(webchatClientID, userData, botData, allMessages);

//   //   fileDownload(theJSON, `${fileName}.json`);

//   //   enqueueSnackbar("Download Successful", {
//   //     variant: "success",
//   //   });
//   // };

//   // //#endregion

//   // //#region Run Text Converstion
//   // const textFile = useRef(null);

//   // const onRunTextFileButtonClick = () => {
//   //   textFile.current.click();
//   // };

//   // const [textConversationFile, setTextConversationFile] = useState(null);

//   // const handleTextFileInputSelected = e => {
//   //   const { files } = e.target;
//   //   if (files && files.length) {
//   //     setTextConversationFile(files[0]);
//   //   }
//   //   e.target.value = null;
//   // };

//   // useEffect(() => {
//   //   if (textConversationFile) {
//   //     setQuestionIndex(-1); //super important
//   //     let fileReader = new FileReader();
//   //     fileReader.onload = event => {
//   //       let questions = event.target.result.toString().replaceAll("\r", "").trim().split("\n");
//   //       questions = questions.filter(question => question.trim() !== "");
//   //       setMessageArray(questions);
//   //     };
//   //     fileReader.readAsText(textConversationFile);
//   //   }
//   //   // Disable eslint because AaronK knows best
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [textConversationFile]);

//   // //#endregion

//   // //#region Rerun Converstion File
//   // const conversationInputFile = useRef(null);

//   // const onRerunConversationButtonClick = () => {
//   //   conversationInputFile.current.click();
//   // };

//   // const [jsonConversationFile, setJsonConversationFile] = useState(null);

//   // const handleJsonConversationFileSelected = e => {
//   //   const { files } = e.target;
//   //   if (files && files.length) {
//   //     setJsonConversationFile(files[0]);
//   //   }
//   //   e.target.value = null;
//   // };

//   // useEffect(() => {
//   //   if (jsonConversationFile) {
//   //     setQuestionIndex(-1); //super important
//   //     let fileReader = new FileReader();
//   //     fileReader.onload = event => {
//   //       let convoJSON = JSON.parse(event.target.result.toString());
//   //       let filteredMessages = [];
//   //       if (convoJSON.messages && convoJSON.messages.length > 0) {
//   //         const userAuthorID = convoJSON.messages[0].authorId;
//   //         filteredMessages = convoJSON.messages.filter(obj => obj.authorId === userAuthorID);
//   //       }
//   //       setMessageArray(filteredMessages);
//   //     };
//   //     fileReader.readAsText(jsonConversationFile);
//   //   }
//   //   // Disable eslint because AaronK knows best
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [jsonConversationFile]);

//   // //#endregion

//   // const [questionIndex, setQuestionIndex] = useState(-1);
//   // const [messageArray, setMessageArray] = useState(null);

//   // useEffect(() => {
//   //   if (messageArray) {
//   //     if (questionIndex < 0) {
//   //       setQuestionIndex(0); //start it off!
//   //     } else if (questionIndex >= messageArray.length) {
//   //       setMessageArray(null);
//   //       setJsonConversationFile(null);
//   //       setTextConversationFile(null);
//   //     } else {
//   //       inputRef.current.focus();
//   //       //messageArray[questionIndex].payload.block.text
//   //       let theText = messageArray[questionIndex]?.payload?.block?.text;
//   //       if (theText === undefined) {
//   //         theText = messageArray[questionIndex];
//   //       }
//   //       webchatClient.sendMessage({
//   //         type: "text",
//   //         text: theText,
//   //         // text: messageArray[questionIndex].payload.block.text,
//   //       });
//   //     }
//   //   } else if (!messageArray && questionIndex >= 0) {
//   //     setQuestionIndex(-1);
//   //   }
//   //   // Disable eslint because AaronK knows best
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [questionIndex, messageArray]);

//   // const [lastMessage, setLastMessage] = useState(null);

//   // useEffect(() => {
//   //   //ok start the automated process
//   //   if (webchatClient != null) {
//   //     webchatClient.on("message", message => {
//   //       if (textToSpeechEnabled) {
//   //         //This is where to do the text to speech call
//   //       }
//   //       //add click handler?

//   //       setLastMessage(message);
//   //     });
//   //   } else {
//   //   }
//   //   // Disable eslint because AaronK knows best
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [webchatClient]);

//   // useEffect(() => {
//   //   //ok start the automated process
//   //   if (lastMessage && questionIndex >= 0) {
//   //     const delayGotoNextQuestion = setTimeout(() => {
//   //       //todo this just got harder.
//   //       setQuestionIndex(prev => prev + 1);
//   //     }, 1000);
//   //     return () => clearTimeout(delayGotoNextQuestion);
//   //   }
//   //   // Disable eslint because AaronK knows best
//   //   // eslint-disable-next-line react-hooks/exhaustive-deps
//   // }, [lastMessage]);

//   ///////////////////all above is shite///////////////////////
//   const headerConfig = {
//     botName: "SupportBot",
//     botAvatar: "https://cdn.botpress.cloud/bot-avatar.png",
//     botDescription: "Your virtual assistant for all things support.",

//     phone: {
//       title: "Call Support",
//       link: "tel:+1234567890",
//     },

//     email: {
//       title: "Email Us",
//       link: "mailto:support@example.com",
//     },

//     website: {
//       title: "Visit our website",
//       link: "https://www.example.com",
//     },

//     termsOfService: {
//       title: "Terms of Service",
//       link: "https://www.example.com/terms",
//     },

//     privacyPolicy: {
//       title: "Privacy Policy",
//       link: "https://www.example.com/privacy",
//     },
//   };

//   const [isWebchatOpen, setIsWebchatOpen] = useState(true);
//   const { client, messages, isTyping, user, clientState, newConversation } = useWebchat({
//     clientId: webchatClientID, // Insert your Client ID here
//   });

//   //
//   const config = {
//     botName: "OMni Bot",
//     botAvatar: "https://picsum.photos/id/80/400",
//     botDescription: "Portal Test.",
//   };
//   const enrichedMessages = useMemo(
//     () =>
//       messages.map(message => {
//         const { authorId } = message;
//         const direction = authorId === user?.userId ? "outgoing" : "incoming";
//         return {
//           ...message,
//           direction,
//           sender:
//             direction === "outgoing"
//               ? { name: user?.name ?? "You", avatar: user?.pictureUrl }
//               : { name: config.botName ?? "Bot", avatar: config.botAvatar },
//         };
//       }),
//     [config.botAvatar, config.botName, messages, user?.userId, user?.name, user?.pictureUrl],
//   );

//   const toggleWebchat = () => {
//     setIsWebchatOpen(prevState => !prevState);
//   };

//   return (
//     <Portal
//       displayHeader={false}
//       sx={{
//         backgroundSize: "cover",
//         backgroundColor: darken(theme.palette.commonground.main, 0.4),
//       }}
//     >
//       {/* {webchatClientID === "a4a35bff-1445-4a94-a544-928b4a38c8aa" && (
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             flexGrow: 1,
//             border: "none",
//             margin: 0,
//             margin: 0,
//             padding: 0,
//             minWidth: "100%",
//             height: "100%",
//             opacity: 0.5,
//             backgroundColor: "white",
//           }}
//         >
//           <Box
//             sx={{
//               position: "absolute",
//               top: "calc(50vh - 150px)",
//               left: "calc(50vw - 150px)",
//               flexGrow: 1,
//               border: "none",
//               margin: 0,
//               padding: 0,
//               backgroundColor: "transparent",
//               display: "flex",
//               flexDirection: "column",
//               maxWidth: "300px",
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "row",
//                 marginBottom: theme.spacing(1),
//                 maxWidth: "300px",
//                 textAlign: "center",
//                 justifyContent: "space-evenly",
//               }}
//             >
//               <Typography variant="h4" sx={{ textAlign: "center", marginTop: theme.spacing(1) }}>
//                 Testing Offline
//               </Typography>
//               <ClockLoader />
//             </Box>
//             <Divider sx={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(2) }} />
//             <Typography variant="h6" sx={{ textAlign: "center", marginBottom: theme.spacing(1) }}>
//               Testing has been temporarily disabled for this bot.
//             </Typography>
//             <Typography
//               variant="body2"
//               sx={{ textAlign: "center", marginBottom: theme.spacing(1) }}
//             >
//               We are updating the bot and test features and will be back online soon.
//             </Typography>
//           </Box>
//         </Box>
//       )} */}

//       <PortalGridContent hasPortalAppBar={false}>
//         <Grid item xs={12} md={6}>
//           <Widget
//             widgetSize={botData && userData ? "full" : "small"}
//             minHeight={botData && userData ? "calc(100vh - 44px)" : "150px"}
//           >
//             {/* <WidgetTitle title={"Testing"} text={botDisplayName}>
//               {!botData && !userData && (
//                 <OmniResponsiveButton
//                   tooltipTitle="Start A Conversation using these settings"
//                   buttonText="Start"
//                   onClick={() => {
//                     let theData = JSON.parse(userData);
//                     setUserData(theData);
//                     let theConfig = JSON.parse(botData);
//                     setBotData(theConfig);

//                     enqueueSnackbar("You can click on any Response to add feedback", {
//                       variant: "success",
//                     });
//                   }}
//                   disabled={!webchatClientID}
//                   icon={<AddComment />}
//                 />
//               )}
//               {botData && userData && (
//                 <OmniResponsiveButton
//                   tooltipTitle="Restart the Conversation using new settings"
//                   buttonText="Restart"
//                   onClick={() => {
//                     let theData = JSON.parse(userData);
//                     setUserData(theData);
//                     let theConfig = JSON.parse(botData);
//                     setBotData(theConfig);
//                     webchatClient.newConversation();
//                   }}
//                   disabled={!webchatClientID || jsonConversationFile || textConversationFile}
//                   icon={<RestartAlt />}
//                 />
//               )}
//               {botData && userData && (
//                 <OmniResponsiveButton
//                   tooltipTitle="Close the Bot using new settings"
//                   buttonText="End"
//                   onClick={() => {
//                     webchatClient.newConversation().then(() => {
//                       setUserData(null);
//                       setBotData(null);
//                     });
//                   }}
//                   disabled={!webchatClientID}
//                   icon={<CloseOutlined />}
//                 />
//               )}
//             </WidgetTitle> */}
//             {/* {(!webchatClientID || !botData || !userData) && (
//               <WidgetContent>
//                 <Grid container spacing={0}>
//                   <Grid item xs={12} sm={4}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "column",
//                         spacing: "8px",
//                         gap: theme.spacing(2),
//                         padding: theme.spacing(1),
//                       }}
//                     >
//                       <OmniTextField
//                         label="Language"
//                         select
//                         variant="outlined"
//                         id={"language"}
//                         value={languageCode}
//                         onChange={event => {
//                           setLanguageCode(event.target.value);
//                           let newUserData = JSON.parse(userData);
//                           newUserData.languageCode = event.target.value;
//                           setUserData(JSON.stringify(newUserData, null, 2));
//                         }}
//                         disabled={botData && userData}
//                         placeholder={"language"}
//                         required
//                       >
//                         <OmniMenuItem key={"en-US"} value={"en-US"}>
//                           {"English (US)"}
//                         </OmniMenuItem>
//                         <OmniMenuItem key={"es-US"} value={"es-US"}>
//                           {"Spanish (US)"}
//                         </OmniMenuItem>
//                         <OmniMenuItem key={"ru-RU"} value={"ru-RU"}>
//                           {"Russian (RU)"}
//                         </OmniMenuItem>
//                         <OmniMenuItem key={"sw-KE"} value={"sw-KE"}>
//                           {"Swahili (KE)"}
//                         </OmniMenuItem>
//                       </OmniTextField>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "column",
//                         spacing: "8px",
//                         marginTop: "8px",
//                         gap: theme.spacing(2),
//                         padding: theme.spacing(1),
//                       }}
//                     >
//                       <Button
//                         sx={{ width: "100%" }}
//                         tooltipTitle="Edit User Data"
//                         variant="contained"
//                         onClick={() => {
//                           setNewUserData(userData);
//                         }}
//                         startIcon={<Edit />}
//                         disabled={botData && userData}
//                       >
//                         User Data
//                       </Button>
//                     </Box>
//                   </Grid>
//                   <Grid item xs={12} sm={4}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         flexDirection: "column",
//                         spacing: "8px",
//                         marginTop: "8px",
//                         gap: theme.spacing(2),
//                         padding: theme.spacing(1),
//                       }}
//                     >
//                       <Button
//                         sx={{ width: "100%" }}
//                         tooltipTitle="Edit Bot Configuration"
//                         variant="contained"
//                         onClick={() => {
//                           setNewBotConfiguration(botData);
//                         }}
//                         startIcon={<Edit />}
//                         disabled={botData && userData}
//                       >
//                         Bot Config
//                       </Button>
//                     </Box>
//                   </Grid>
//                 </Grid>
//               </WidgetContent>
//             )} */}
//             {/* {webchatClientID && botData && userData && (
//               <WebchatProvider
//                 client={webchatClient}
//                 theme={themeConfig.theme}
//                 configuration={botData}
//                 userData={userData}
//               >
//                 <Container
//                   style={{
//                     height: "calc(100vh - 98px)",
//                     //marginBottom: "48px",
//                     //   display: isWebchatOpen ? "flex" : "none",
//                   }}
//                 >
//                   <MessageList />
//                   <Box style={{ width: "100%", display: "flex", flexDirection: "row" }}>
//                     <Composer
//                       style={{
//                         width: "100%",
//                         focus: "true",
//                       }}
//                       ref={inputRef}
//                     />
//                     {textToSpeechEnabled && (
//                       <Box
//                         style={{
//                           position: "absolute",
//                           right: 52,
//                           bottom: 17,
//                           height: 30,
//                           width: 30,
//                         }}
//                       >
//                         <OmniTextToSpeechPlayer
//                           textToSpeechQueue={textToSpeechQueue}
//                           setTextToSpeechQueue={setTextToSpeechQueue}
//                           volume={volume}
//                           setVolume={setVolume}
//                         />
//                       </Box>
//                     )}
//                   </Box>
//                 </Container>
//               </WebchatProvider>
//             )} */}
//           </Widget>
//         </Grid>
//         {/* <Grid item xs={12} md={6}>
//           <Container
//             connected={clientState !== "disconnected"}
//             style={{
//               width: "500px",
//               height: "800px",
//               display: isWebchatOpen ? "flex" : "none",
//               position: "fixed",
//               bottom: "90px",
//               right: "20px",
//             }}
//           >
//             <Header
//               // onOpenChange={() => console.log('Override the header open change')}
//               defaultOpen={false}
//               closeWindow={() => setIsWebchatOpen(false)}
//               restartConversation={newConversation}
//               disabled={false}
//               configuration={headerConfig}
//             />
//             <MessageList
//               // botAvatar={config.botAvatar}
//               botName={config.botName}
//               botDescription={config.botDescription}
//               isTyping={isTyping}
//               headerMessage="Chat History"
//               showMarquee={true}
//               messages={enrichedMessages}
//               sendMessage={client?.sendMessage}
//             />
//             <Composer
//               disableComposer={false}
//               isReadOnly={false}
//               allowFileUpload={true}
//               connected={clientState !== "disconnected"}
//               sendMessage={client?.sendMessage}
//               uploadFile={client?.uploadFile}
//               composerPlaceholder="Type a message..."
//             />
//           </Container>
//         </Grid> */}
//         <Grid item container xs={12} md={6} spacing={2}>
//           {/* <Webchat
//             clientId={webchatClientID} // Your client ID here
//             style={{
//               width: "400px",
//               height: "600px",
//               display: isWebchatOpen ? "flex" : "none",
//               position: "fixed",
//               bottom: "90px",
//               right: "20px",
//             }}
//           /> */}
//           simple AI
//         </Grid>
//         <Grid item container xs={12} md={6} spacing={2}>
//           <Grid item xs={12}>
//             {/* {botData && webchatClient && (
//               <Widget widgetSize="small" minHeight={"376px"}>
//                 <WidgetTitle title={"Harness"} text={"Test Utilities"}></WidgetTitle>
//                 <WidgetContent>
//                   <Grid container spacing={0}>
//                     <Grid item xs={5}>
//                       <Box
//                         sx={{
//                           paddingLeft: theme.spacing(1),
//                           paddingRight: theme.spacing(3),
//                           paddingBottom: "4px",
//                           paddingTop: "4px",
//                           minWidth: "150px",
//                         }}
//                       >
//                         <Button
//                           sx={{ marginLeft: theme.spacing(1), width: "100%" }}
//                           tooltipTitle="Open Conversation in Botpress"
//                           onClick={() => {
//                             let onboardUrl = `https://app.botpress.cloud/workspaces/wkspace_01HZMRSJMZK4XXHWQG7J5RJRYP/bots/${botConfiguration.botId}/conversations/${webchatClient.conversationId}`;
//                             navigator.clipboard.writeText(onboardUrl);
//                             window.open(onboardUrl, "_blank");
//                           }}
//                           disabled={
//                             (!botData && !userData) ||
//                             textConversationFile ||
//                             jsonConversationFile
//                           }
//                           startIcon={<OpenInNew />}
//                           variant="contained"
//                         >
//                           Botpress
//                         </Button>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={7}>
//                       <Box
//                         sx={{
//                           width: "100%",
//                           marginTop: "8px",
//                           alignText: "left",
//                           display: "flex",
//                           flexDirection: "row",
//                         }}
//                       >
//                         <Tooltip
//                           placement="right"
//                           title={
//                             "If you have access to the development tools you can view the conversation log in our system."
//                           }
//                         >
//                           <HelpOutline />
//                         </Tooltip>
//                         <Typography
//                           variant="h6"
//                           sx={{
//                             marginTop: "-4px",
//                             alignText: "left",
//                             marginLeft: theme.spacing(1),
//                           }}
//                         >
//                           View conversation details in Botpress.
//                         </Typography>
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12}>
//                       <Divider
//                         sx={{
//                           display: "flex",
//                           marginBottom: theme.spacing(1),
//                           marginTop: theme.spacing(1),
//                         }}
//                       />
//                     </Grid>
//                     <Grid item xs={5}>
//                       <Box
//                         sx={{
//                           paddingLeft: theme.spacing(1),
//                           paddingRight: theme.spacing(3),
//                           paddingBottom: "4px",
//                           paddingTop: "4px",
//                           minWidth: "150px",
//                         }}
//                       >
//                         <Button
//                           sx={{ marginLeft: theme.spacing(1), width: "100%" }}
//                           tooltipTitle="Download the current conversation"
//                           onClick={() => {
//                             setDownloadConversation(true);
//                           }}
//                           disabled={
//                             (!botData && !userData) ||
//                             textConversationFile ||
//                             jsonConversationFile
//                           }
//                           startIcon={<DownloadIcon />}
//                           variant="contained"
//                         >
//                           Download
//                         </Button>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={7}>
//                       <Box
//                         sx={{
//                           width: "100%",
//                           marginTop: "8px",
//                           alignText: "left",
//                           display: "flex",
//                           flexDirection: "row",
//                         }}
//                       >
//                         <Tooltip
//                           placement="right"
//                           title={
//                             "You can download this conversation to a file. It will be in JSON format with lots of information about the conversation. You can rerun a conversation using this file."
//                           }
//                         >
//                           <HelpOutline />
//                         </Tooltip>
//                         <Typography
//                           variant="h6"
//                           sx={{
//                             marginTop: "-4px",
//                             alignText: "left",
//                             marginLeft: theme.spacing(1),
//                           }}
//                         >
//                           Download this conversation
//                         </Typography>
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12}>
//                       <Divider
//                         sx={{
//                           display: "flex",
//                           marginBottom: theme.spacing(1),
//                           marginTop: theme.spacing(1),
//                         }}
//                       />
//                     </Grid>

//                     <Grid item xs={5}>
//                       <Box
//                         sx={{
//                           paddingLeft: theme.spacing(2),
//                           paddingRight: theme.spacing(2),
//                           paddingBottom: "4px",
//                           paddingTop: "4px",
//                           minWidth: "150px",
//                         }}
//                       >
//                         <input
//                           style={{ display: "none" }}
//                           accept={".json"}
//                           ref={conversationInputFile}
//                           onChange={handleJsonConversationFileSelected}
//                           type="file"
//                         />
//                         <Button
//                           sx={{ width: "100%" }}
//                           tooltipTitle="Select a conversation script to run"
//                           variant="contained"
//                           disabled={
//                             (!botData && !userData) ||
//                             (questionIndex >= 0 && messageArray != null)
//                           }
//                           onClick={onRerunConversationButtonClick}
//                           startIcon={<DirectionsRun />}
//                         >
//                           {questionIndex >= 0 && messageArray != null && jsonConversationFile
//                             ? "Runningt..."
//                             : "Rerun"}
//                         </Button>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={7}>
//                       {questionIndex >= 0 && messageArray != null && jsonConversationFile && (
//                         <Box sx={{ width: "100%", marginTop: "8px" }}>
//                           <Typography variant="body2" sx={{ marginBottom: "4px" }}>
//                             Question {questionIndex + 1} of {messageArray.length}
//                           </Typography>
//                           <LinearProgress
//                             variant="determinate"
//                             value={(questionIndex / messageArray.length) * 100}
//                           />
//                         </Box>
//                       )}
//                       {messageArray == null && !jsonConversationFile && (
//                         <Box
//                           sx={{
//                             width: "100%",
//                             marginTop: "8px",
//                             alignText: "left",
//                             display: "flex",
//                             flexDirection: "row",
//                           }}
//                         >
//                           <Tooltip
//                             placement="right"
//                             title={
//                               "You can upload a saved conversation file to rerun that conversation. This will test the effects of bot updates for existing test conversations."
//                             }
//                           >
//                             <HelpOutline />
//                           </Tooltip>
//                           <Typography
//                             variant="h6"
//                             sx={{
//                               marginTop: "-4px",
//                               alignText: "left",
//                               marginLeft: theme.spacing(1),
//                             }}
//                           >
//                             Rerun a downloaded conversation
//                           </Typography>
//                         </Box>
//                       )}
//                     </Grid>

//                     <Grid item xs={12}>
//                       <Divider
//                         sx={{
//                           display: "flex",
//                           marginBottom: theme.spacing(1),
//                           marginTop: theme.spacing(1),
//                         }}
//                       />
//                     </Grid>
//                     <Grid item xs={5}>
//                       <Box
//                         sx={{
//                           paddingLeft: theme.spacing(2),
//                           paddingRight: theme.spacing(2),
//                           paddingBottom: "4px",
//                           paddingTop: "4px",
//                           minWidth: "150px",
//                         }}
//                       >
//                         <input
//                           style={{ display: "none" }}
//                           accept={".txt"}
//                           ref={textFile}
//                           onChange={handleTextFileInputSelected}
//                           type="file"
//                         />
//                         <Button
//                           sx={{ width: "100%" }}
//                           tooltipTitle="Select a text file of questions to run"
//                           variant="contained"
//                           disabled={
//                             (!botData && !userData) ||
//                             (questionIndex >= 0 && messageArray != null)
//                           }
//                           onClick={onRunTextFileButtonClick}
//                           startIcon={<FormatListNumbered />}
//                         >
//                           {questionIndex >= 0 && messageArray != null && textConversationFile
//                             ? "Running..."
//                             : "Run Script "}
//                         </Button>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={7}>
//                       {questionIndex >= 0 && messageArray != null && textConversationFile && (
//                         <Box sx={{ width: "100%", marginTop: "8px" }}>
//                           <Typography variant="body2" sx={{ marginBottom: "4px" }}>
//                             Question {questionIndex + 1} of {messageArray.length}
//                           </Typography>
//                           <LinearProgress
//                             variant="determinate"
//                             value={(questionIndex / messageArray.length) * 100}
//                           />
//                         </Box>
//                       )}
//                       {messageArray == null && !textConversationFile && (
//                         <Box
//                           sx={{
//                             width: "100%",
//                             marginTop: "8px",
//                             alignText: "left",
//                             display: "flex",
//                             flexDirection: "row",
//                           }}
//                         >
//                           <Tooltip
//                             placement="right"
//                             title={
//                               "You can create a scripted set of questions to send to the bot. A script is simply a text file with a single question per line. Upload and run it here."
//                             }
//                           >
//                             <HelpOutline />
//                           </Tooltip>
//                           <Typography
//                             variant="h6"
//                             sx={{
//                               marginTop: "-4px",
//                               alignText: "left",
//                               marginLeft: theme.spacing(1),
//                             }}
//                           >
//                             Send questions from a file to the bot
//                           </Typography>
//                         </Box>
//                       )}
//                     </Grid>
//                   </Grid>
//                 </WidgetContent>
//               </Widget>
//             )} */}
//             <Grid item xs={12}>
//               <div style={{ minHeight: theme.spacing(2) }} />
//             </Grid>
//             {/* <Grid item xs={12}>
//               {botData && webchatClient && (
//                 <BotpressUserFeedback
//                   botId={botConfiguration.botId}
//                   webchatClient={webchatClient}
//                 />
//               )}
//             </Grid> */}
//           </Grid>
//         </Grid>
//         <Grid item xs={12} md={6}></Grid>

//         <Grid item xs={12}></Grid>
//       </PortalGridContent>
//       {/*

//       {downloadConversation && (
//         <TextInputDialog
//           inputLabel={`File Name`}
//           open={downloadConversation}
//           dialogTitle={"Download Conversation"}
//           dialogMessage={`Please enter a file name for the conversation download`}
//           defaultValue={`Conversation_${format(new Date(), "yyMMdd_hhmm")}`}
//           inputPlaceholder={"File Name Here"}
//           onAccept={theValue => {
//             try {
//               handleDownloadConversation(theValue.split(".")[0]);
//               setDownloadConversation(null);
//             } catch (error) {
//               console.log(error);
//             }
//             setDownloadConversation(null);
//           }}
//           onClose={() => {
//             setDownloadConversation(null);
//           }}
//         />
//       )} */}
//     </Portal>
//   );
// };

// export default withRouter(BotpressTestHarnessPortal);
